module.exports = __webpack_public_path__ + "static/assets/a1c3a69e7f7cdb0633bd03ae1162c637.svg";